import {Box, SvgIcon} from "@mui/material";
import React from "react";

export function AccessoriesIcon(props) {
  return(
      <img src="/Icons/accessories.svg" alt="accessories" {...props}/>
  )
}